import React, { useState, useEffect } from 'react';
import { FaCrown, FaCheck } from 'react-icons/fa';
import { subscriptionsAPI } from '../utils/api';
import { toast } from 'sonner';

const SubscribeButton = ({ userId, currentUserId }) => {
  const [creatorData, setCreatorData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [acting, setActing] = useState(false);

  useEffect(() => {
    if (!userId || userId === currentUserId) { setLoading(false); return; }
    subscriptionsAPI.getCreator(userId).then(res => {
      if (res.data.is_creator) setCreatorData(res.data);
    }).catch(() => {}).finally(() => setLoading(false));
  }, [userId, currentUserId]);

  if (loading || !creatorData) return null;

  const handleToggle = async () => {
    setActing(true);
    try {
      if (creatorData.is_subscribed) {
        await subscriptionsAPI.unsubscribe(userId);
        setCreatorData(prev => ({ ...prev, is_subscribed: false, subscriber_count: prev.subscriber_count - 1 }));
        toast.success('Unsubscribed');
      } else {
        const res = await subscriptionsAPI.subscribe(userId);
        setCreatorData(prev => ({ ...prev, is_subscribed: true, subscriber_count: prev.subscriber_count + 1 }));
        toast.success(res.data.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed');
    } finally {
      setActing(false);
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={acting}
      data-testid="subscribe-btn"
      className={`flex items-center gap-1.5 px-3 py-1.5 md:px-4 md:py-2 rounded-xl text-xs md:text-sm font-semibold transition-all ${
        creatorData.is_subscribed
          ? 'bg-amber-50 text-amber-600 border border-amber-200 hover:bg-amber-100'
          : 'bg-gradient-to-r from-amber-500 to-orange-500 text-white hover:shadow-lg'
      } disabled:opacity-50`}
    >
      {creatorData.is_subscribed ? <><FaCheck size={12} /> Subscribed</> : <><FaCrown size={12} /> Subscribe · {creatorData.subscription_price} <span className="font-arthaus">PP</span></>}
    </button>
  );
};

export default SubscribeButton;
